import { all } from "redux-saga/effects";
import { dashboardSaga } from "./sagas/dashboardSaga";
import authSaga from "./sagas/authSaga";
import vehicleAccountSaga from "./sagas/VehicleAccountSaga";
import { focMasterSaga } from "./sagas/focMasterSaga";
import historySaga from "./sagas/VehicleHistorySaga";
import corporateSaga from "./sagas/corporateSaga";
import prepaidSaga from "./sagas/prepaidSaga";
import corporatetripSaga from "./sagas/CorporateTripSaga";
import DriverAttenSaga from "./sagas/DriverAttenSaga";
import bookingSaga from "./sagas/bookingReportSaga";
import driverdetailsSaga from "./sagas/DriverSaga";
import ownerdetailsSaga from "./sagas/OwnerSaga";
import statusreportSaga from "./sagas/StatusReportSaga";
import vehicleMasterSaga from "./sagas/VehicleMasterSaga";
import drivercallSaga from "./sagas/DriverCallSaga";
export default function* rootSaga() {
  yield all([
    dashboardSaga(),
    authSaga(),
    vehicleAccountSaga(),
    focMasterSaga(),
    historySaga(),
    corporateSaga(),
    prepaidSaga(),
    corporatetripSaga(),
    DriverAttenSaga(),
    bookingSaga(),
    driverdetailsSaga(),
    ownerdetailsSaga(),
    statusreportSaga(),
    vehicleMasterSaga(),
    drivercallSaga(),
  ]);
}
